import { render, staticRenderFns } from "./courseChild.vue?vue&type=template&id=e637dd22&scoped=true"
import script from "./courseChild.vue?vue&type=script&lang=js"
export * from "./courseChild.vue?vue&type=script&lang=js"
import style0 from "./courseChild.vue?vue&type=style&index=0&id=e637dd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e637dd22",
  null
  
)

export default component.exports